export default __webpack_public_path__ + "static/media/feedioolive.8f3d94a9.png";